import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDevTools, isDevToolsVisible } from "../../../context/DevToolsContext.js";
const DIFFICULTY_CONFIG = {
  1: { label: "Lv.1", className: "bg-emerald-100 text-emerald-700" },
  2: { label: "Lv.2", className: "bg-sky-100 text-sky-700" },
  3: { label: "Lv.3", className: "bg-amber-100 text-amber-700" },
  4: { label: "Lv.4", className: "bg-orange-100 text-orange-700" },
  5: { label: "Lv.5", className: "bg-rose-100 text-rose-700" }
};
function DifficultyBadge({ level }) {
  if (level == null) return null;
  const config = DIFFICULTY_CONFIG[level] ?? { label: `Lv.${level}`, className: "bg-gray-100 text-gray-600" };
  return /* @__PURE__ */ jsx("span", { className: `inline-flex items-center px-1.5 py-0.5 text-[10px] font-bold rounded-xs ${config.className}`, children: config.label });
}
function DebugQuizId({ quizId }) {
  const { t } = useTranslation("quiz");
  const { userEmail } = useDevTools();
  const [copied, setCopied] = useState(false);
  if (!isDevToolsVisible(userEmail)) return null;
  const id = String(quizId);
  const handleCopy = () => {
    navigator.clipboard.writeText(id);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-0.5 text-xs font-mono ml-2", children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        onClick: handleCopy,
        className: "px-1.5 py-0.5 text-gray-400 bg-gray-100 rounded-l hover:bg-gray-200 hover:text-gray-600 transition-colors cursor-pointer",
        title: t("shared.copyQuizId"),
        children: copied ? "copied!" : id
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        onClick: () => window.open(`https://adm.quebon.tv/quiz?type=&category=id&by=modified&findText=${id}`, "_blank"),
        className: "px-1 py-0.5 text-gray-400 bg-gray-100 rounded-r hover:bg-gray-200 hover:text-gray-600 transition-colors cursor-pointer",
        title: t("shared.viewInAdmin"),
        children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", className: "w-3.5 h-3.5", children: /* @__PURE__ */ jsx("path", { fillRule: "evenodd", d: "M4.25 5.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 1 1.5 0v4A2.25 2.25 0 0 1 12.75 17h-8.5A2.25 2.25 0 0 1 2 14.75v-8.5A2.25 2.25 0 0 1 4.25 4h5a.75.75 0 0 1 0 1.5h-5Zm7.25-.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0V6.31l-5.47 5.47a.75.75 0 1 1-1.06-1.06l5.47-5.47H12.25a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }) })
      }
    )
  ] });
}
export {
  DebugQuizId,
  DifficultyBadge
};
//# sourceMappingURL=debug-quiz-id.js.map
